export const CLEAR = 'CLEAR'
export const CHANGE_THRESHOLD = 'CHANGE_THRESHOLD'
export const FETCH_GROUPS = 'FETCH_GROUPS'
export const FETCH_QUARTILE_LOCATIONS = 'FETCH_QUARTILE_LOCATIONS'

export default {
  CLEAR,
  CHANGE_THRESHOLD,
  FETCH_GROUPS,
  FETCH_QUARTILE_LOCATIONS
}
